import { supabase } from "../supabase/supabaseClient";

export const getEducations = async (userId) => {
    return await supabase
        .from("player_educations")
        .select("*")
        .eq("user_id", userId)
        .order("start_date", { ascending: false });
};

export const createEducation = async (userId, education) => {
    return await supabase
        .from("player_educations")
        .insert([{ user_id: userId, ...education }])
        .select()
        .single();
};

export const updateEducation = async (educationId, updates) => {
    return await supabase
        .from("player_educations")
        .update(updates)
        .eq("id", educationId)
        .select()
        .single();
};

export const deleteEducation = async (educationId) => {
    return await supabase
        .from("player_educations")
        .delete()
        .eq("id", educationId);
};
